<template>
  <div class="s-information-container">
    <topNav></topNav>
    <div class="s-information-top">
      <div class="banner w1300 marginAuto"></div>
    </div>
    <div class="s-information-content w1300 marginAuto">
      <div class="s-information-item">
        <el-carousel :interval="5000" class="index-el-carousel">
          <el-carousel-item v-for="(item, index) in lastNewsList.slice(0, 5)" :key="index">
            <img :src="item.imgUrlBank" alt class="img" />
            <div class="title">
              <p class="title_p">{{ item.informationTitle }}</p>
            </div>
          </el-carousel-item>
        </el-carousel>
        <div class="s-information-list">
          <div class="s-information-li" v-for="(item, index) in leftNewsList" :key="index" @click="goDetial(item, '新闻中心')">
            <span class="circle"></span>
            <span class="title">{{ item.informationTitle }}</span>
            <span class="date">{{ item.uploadDate.slice(0, 10) }}</span>
          </div>
        </div>
      </div>
      <div class="s-information-item">
        <div class="s-information-title">
          <img :src="require('@/assets/image/news/news.png')" alt class="news-icon" />
          <span class="text">新闻中心</span>
          <span class="border"></span>
        </div>
        <div class="s-information-list">
          <div class="s-information-li" v-for="(item, index) in rightNewsList" :key="index"
            @click="goDetial(item, '新闻中心')">
            <span class="circle"></span>
            <span class="title">{{ item.informationTitle }}</span>
            <span class="date">{{ item.uploadDate.slice(0, 10) }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="s-information-content w1300 marginAuto">
      <div class="s-information-item">
        <div class="s-information-title">
          <img :src="require('@/assets/image/news/notice.png')" alt class="news-icon" />
          <span class="text">通知公告</span>
          <span class="border"></span>
          <div class="btn">
            <span class="btn_l" @click="paginationChange('announcementsList', 1)"></span>
            <span class="btn_r" @click="paginationChange('announcementsList', 2)"></span>
          </div>
        </div>
        <!-- <div class="s-information-list">
          <div class="s-information-li" v-for="(item,index) in announcementsList" :key="index" @click="goDetial(item, '通知公告')">
            <span class="circle"></span>
            <span class="title">{{ item.informationTitle }}</span>
            <span class="date">{{ item.uploadDate.slice(0, 10) }}</span>
          </div>
        </div>-->
        <ul class="list-content list-content-especially">
          <li class="list-content-li list-content-li-especially" v-for="(itm, ind) in announcementsList" :key="ind"
            @mouseover="hoverOn(ind)" @mouseout="hoverOut(ind)" @click="goInfoPath(itm)">
            <div class="l-title" v-show="hoverType != ind" @mouseover="hoverOn(ind)" @mouseout="hoverOut(ind)"
              :title="itm.informationTitle || '--'">
              <i class="li-point"></i>
              {{ itm.informationTitle || '--' }}
            </div>
            <div class="r-date" v-show="hoverType != ind" @mouseover="hoverOn(ind)" @mouseout="hoverOut(ind)">
              {{ itm.uploadDate.slice(0, 10) || '--' }}</div>
            <div v-show="hoverType == ind" class="detail-box" @click="goInfoPath(itm)">
              <img :src="itm.img == null ? defaultImg : imgURL + '/' + itm.img" alt class="img" />
              <div class="detail-content">
                <div class="detail-title">{{ itm.informationTitle }}</div>
                <div class="detail" v-html="itm.informationDetailStr"></div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="s-information-item">
        <div class="s-information-title">
          <img :src="require('@/assets/image/news/policy.png')" alt class="news-icon" />
          <span class="text">政策法规</span>
          <span class="border"></span>
          <div class="btn">
            <span class="btn_l" @click="paginationChange('lawsRegulationsList', 1)"></span>
            <span class="btn_r" @click="paginationChange('lawsRegulationsList', 2)"></span>
          </div>
        </div>
        <div class="s-information-list">
          <div class="s-information-li" v-for="(item, index) in lawsRegulationsList" :key="index"
            @click="goDetial(item, '政策法规')">
            <span class="circle"></span>
            <span class="title">{{ item.informationTitle }}</span>
            <span class="date">{{ item.uploadDate.slice(0, 10) }}</span>
          </div>
        </div>
      </div>
    </div>

    <footer-nav></footer-nav>
  </div>
</template>

<script>
import topNav from "../components/topNav.vue";
import footerNav from "../components/footerNav.vue";
import { getInformation } from "./../utils/api/index";

export default {
  name: "information",
  data() {
    return {
      currentTab: "新闻中心",
      totalPages:1,
      totalPages2:1,
      currentPage: 1, // 页码
      currentPage2: 1, // 页码
      pageSize: 7, // 每页显示数量
      total: 0, // 总数
      informationList: [],
      announcementsList: [],
      lawsRegulationsList: [],
      lastNewsList: [],
      defaultImg: require("../assets/image/dealmakers/default.png"),
      hoverType: null
    };
  },
  components: { topNav, footerNav },
  created() {
    this.getInformation("lastNewsList", "新闻中心");
    this.getInformation("informationList", "新闻中心");
    this.getInformation("announcementsList", "通知公告");
    this.getInformation("lawsRegulationsList", "政策法规");
  },

  computed: {
    leftNewsList() {
      let len = this.informationList.length;
      let num = Math.floor((len - 5) / 2);
      return this.informationList.slice(0, num);
    },
    rightNewsList() {
      let len = this.informationList.length;
      let num = Math.ceil((len - 5) / 2);
      return this.informationList.slice(num, len);
    }
  },
  methods: {
    hoverOn(val) {
      this.hoverType = val;
    },
    hoverOut(val) {
      this.hoverType = null;
    },
    //咨询详情
    goInfoPath(item) {
      this.$router.push({
        path: "/informationDetail",
        query: { id: item.id }
      });
    },
    // 跳转详情
    goDetial(item, type) {
      var url = `${location.origin +
        location.pathname}#informationDetail?pageType=${type}&id=${item.id}`;
      window.open(url);
    },
    paginationChange(list, num) {
      if (num == 1) {
        if (list == 'announcementsList') {
          if (this.currentPage > 1) {
            this.currentPage--
            this.getInformation("announcementsList", "通知公告");
          }
        } else {
          if (this.currentPage2 > 1) {
            this.currentPage2--
            this.getInformation("lawsRegulationsList", "政策法规");
          }
        }
      } else {
        if (list == 'announcementsList') {
          if (this.totalPages>this.currentPage) {
            this.currentPage++
            this.getInformation("announcementsList", "通知公告");
          }

        } else {
          if (this.totalPages2>this.currentPage2) {
            this.currentPage2++
            this.getInformation("lawsRegulationsList", "政策法规");
          }
        }
      }
    },
    async getInformation(list, informationType) {
      let params = {
        currentPage: informationType=="政策法规"?this.currentPage2:this.currentPage,
        pageSize: this.pageSize,
        informationType
      };
      let res = await getInformation(params);
      if (res.data.code === 0) {
        if (informationType=="通知公告") {
          this.totalPages = res.data.data.pages
        } else if (informationType=="政策法规") {
          this.totalPages2 = res.data.data.pages
        }
        this[list] = res.data.data.records.map(res => {
          if (res.img != null) {
            res.imgUrlBank = this.imgURL + "/" + res.img.split(",")[0];
          } else {
            res.imgUrlBank = this.defaultImg;
          }
          return res;
        });
        if (list === "lastNewsList") {
          this[list] = this[list].filter(res => res.img);
        }
      }
    }
  }
};
</script>

<style lang="scss">
@import "../utils/css/common.scss";
@import "../utils/css/information.scss";
</style>
<style lang="scss" scoped>
.list-content {
  //height: calc(100% - 52px);
  margin-top: 20px;
  overflow: hidden;
  margin-bottom: 20px;

  .list-content-li {
    height: 48px;
    line-height: 48px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    cursor: pointer;

    .l-title {
      width: 80%;
      line-height: 40px;

      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      .li-point {
        width: 6px;
        height: 6px;
        display: inline-block;
        background-color: #3ca757;
        border-radius: 3px;
        float: left;
        margin-top: 18px;
        margin-right: 8px;
      }
    }

    .r-date {
      width: 20%;
      line-height: 40px;

      color: #666;
      text-align: right;
    }
  }
}

.list-content-especially {
  overflow-y: auto;

  .list-content-li-especially {
    height: auto;
    cursor: pointer;

    .detail-box {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      height: 140px;
      overflow: auto;
      margin-bottom: 10px;

      .img {
        width: 120px;
        height: 120px;
      }

      .detail-content {
        width: calc(100% - 140px);
        height: 120px;

        .detail-title {
          line-height: 40px;
          color: #333;
          font-size: 16px;
          font-weight: 550;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .detail {
          line-height: 30px;
          color: #333;
          font-size: 14px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
        }
      }
    }
  }
}

.list-content-especially::-webkit-scrollbar-thumb {
  border-radius: 6px;
  background-color: rgba(237, 237, 237, 0.8);
}

.list-content-especially::-webkit-scrollbar-track {
  border-radius: 6px;
  background-color: rgba(237, 237, 237, 0.2);
  // background-color: transparent;
}

.list-content-especially::-webkit-scrollbar {
  width: 5px;
  height: 1px;
}
</style>
